// extracted by mini-css-extract-plugin
module.exports = {"label":"_3I35RPJqjoGIFErLKANZfh","wrapper":"_2PhMEgqyzq-tAwM6G8A2dF"};